module.exports = __webpack_public_path__ + "img/CloudOffOutlined.3a84a9bd.svg";